import './Email.css'; // Assuming we put the CSS in this file
import React, { useState, useEffect, useRef } from "react";
import Handlebars from "handlebars"; // Ensure Handlebars is installed
import { Button } from '@mui/material';
import { 
  Send as SendIcon, 
  Group as GroupIcon, 
  Mail as MailIcon, 
  Grading as GradingIcon, 
  Face as FaceIcon,
  MiscellaneousServices as MiscellaneousServicesIcon,
} from '@mui/icons-material'; // Material Icons
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import parse from "html-react-parser";
import Switch from "@mui/material/Switch";
import { styled } from '@mui/material/styles';
import { ViewType, LambdaURLs } from '../../Enums'; // Ensure ViewType is imported correctly

const MaterialUISwitch = (props) => {
  return <Switch {...props} className="material-ui-switch" />;
};



const Email = ({ messages, allSubmissions, reviews, onMessageUpdate, isEmailOpen }) => {
  const [expanded, setExpanded] = useState(false); // Local state to track visibility of content
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [actions, setActions] = useState({
    chooseGroup: false,
    editTemplate: false,
    configureOptions: false,
    checkRecipients: false,
    sendTestMessage: false,
  });
  const [dataCompiled, setDataCompiled] = useState(false);
  const [recipientList, setRecipientList] = useState([]);
  const [compiledEmailObjects, setCompiledEmailObjects] = useState([]);
  const [showRecipients, setShowRecipients] = useState(false);
  const [showConfigure, setShowConfigure] = useState(false);
  const [expandedRecipient, setExpandedRecipient] = useState(null);
  //const subjectRef = useRef();
  //const bodyRef = useRef();
  //const testEmailRef = useRef(null);
  //const testRef = useRef(null);
  //const bccRef = useRef(null);
  //const bccEmailRef = useRef(null);
  //const testMessageRef = useRef(null);
  const [bccEmail, setBccEmail] = useState("");
  const [bccFlag, setBccFlag] = useState(false);
  const [testEmailFlag, setTestEmailFlag] = useState(false);
  const [testEmail, setTestEmail] = useState("");
  const [saveTemplate, setSaveTemplate] = useState(false);
  const [saveAsNewTemplate, setSaveAsNewTemplate] = useState(false);
  const [newTemplateName, setNewTemplateName] = useState("");

    console.log("Email allSubmissions:", allSubmissions);
  useEffect(() => {
    setExpanded(isEmailOpen); // No array needed, just set it directly to the boolean
  }, [isEmailOpen]);

  const findRecipients = (group) => {
    const message = group; // Get the entire message object
    if (!message) {
      console.error(`No message found for group: ${group}`);
      return;
    }
  
    const { messageObjects, recipientList } = filterAndCompileSubmissions(message);

    // Update state
    setCompiledEmailObjects(messageObjects);
    setRecipientList(recipientList);
    setDataCompiled(true);

    console.log("CompiledEmails", messageObjects);
    console.log("recipientList", recipientList);
  }  

  /**
   * Filters submissions and compiles message objects with email content and recipient details.
   *
   * @param {Object} message - The message object containing the template and recipient details.
   * @returns {Object} - An object containing the message objects and the recipient list.
   */
  function filterAndCompileSubmissions(message) {
    const { recipients, template, subject } = message;
  
    if (!recipients || !template || !Array.isArray(recipients.conditions)) {
      throw new Error("Invalid message object: 'recipients.conditions[]' is required.");
    }
  
    const { object, person, conditions } = recipients;
  
    const predicates = {
      ne: (a, b) => a !== b,
      eq: (a, b) => a === b,
      gt: (a, b) => a > b,
      lt: (a, b) => a < b,
      gte: (a, b) => a >= b,
      lte: (a, b) => a <= b,
    };
  
    let itemsToSearch;
    switch (object) {
      case "submission":
        itemsToSearch = allSubmissions;
        break;
      case "review":
        itemsToSearch = reviews;
        break;
      default:
        throw new Error(`Unsupported object type: ${object}`);
    }

    console.log("itemsToSearch:", itemsToSearch);
    console.log("allSubmissions:", allSubmissions);
  
    if (!Array.isArray(itemsToSearch)) {
      throw new Error(`Data source for object '${object}' is missing or invalid.`);
    }
  
    const parsedItems = itemsToSearch.map((item) => {
      const itemCopy = JSON.parse(JSON.stringify(item));
      if (typeof itemCopy.meta?.owner === "string") {
        try {
          itemCopy.meta.owner = JSON.parse(itemCopy.meta.owner);
        } catch (err) {
          console.warn("Failed to parse meta.owner:", itemCopy.meta.owner, err);
        }
      }
      return itemCopy;
    });
  
    const filteredItems = parsedItems.filter((item) => {
      return conditions.every(({ dataSource, predicate, value }) => {
        const dataSourceKeys = dataSource.split(".");
        const dataSourceValue = dataSourceKeys.reduce((acc, key) => acc?.[key], item);
        const evaluate = predicates[predicate];
        if (!evaluate) throw new Error(`Unsupported predicate: ${predicate}`);
        return evaluate(dataSourceValue, value);
      });
    });
  
    const compiledTemplate = Handlebars.compile(template);
  
    const messageObjects = filteredItems.map((item) => {
      const owner = item.meta?.owner || {};
      const { email = "", givenName = "", familyName = "" } = owner;
      return {
        subject,
        body: compiledTemplate(item),
        recipient: { email, givenName, familyName }
      };
    });
  
    const recipientMap = new Map();
    messageObjects.forEach(({ recipient }) => {
      const { email, givenName, familyName } = recipient;
      if (!recipientMap.has(email)) {
        recipientMap.set(email, { email, givenName, familyName, count: 1 });
      } else {
        recipientMap.get(email).count++;
      }
    });
  
    const recipientList = Array.from(recipientMap.values()).sort((a, b) =>
      a.email.localeCompare(b.email)
    );
  
    return { messageObjects, recipientList };
  }
  

  const handleGroupSelect = (group) => {
    console.log("Selected group:", group);
  
    const message = messages[group];
    if (!message) {
      console.error(`No message found for group: ${group}`);
      return;
    }
  
    console.log("Selected message:", message);
    console.log("Boolean(message.bcc):", Boolean(message.bcc));
  
    setSelectedMessage(message);
    setDataCompiled(false);
    setActions({ ...actions, chooseGroup: true });
  };
  

  const handleActionChange = (action) => {
    setActions((prevActions) => ({
      ...prevActions,
      [action]: !prevActions[action],
    }));
  };
  
  const toggleConfigure = () => {     
    saveIfRequired();
    
    // Only compile recipients if opening the area and the data doesn't exist yet
    if (!showConfigure) {
      if(!dataCompiled)
        findRecipients(selectedMessage);

      const message = selectedMessage; // Get the entire message object
      if (message?.bcc) {
        setBccFlag(true);
        setBccEmail(message.bcc); // Update state with the email address
      }
   } else {
     setActions({
       ...actions,
       configureOptions: true,
     });
   }
    setShowRecipients(false);
    setShowConfigure((prev) => !prev);
  };


  //N.B. WE DO NOT GET ALL THE LATEST SETTINGS BEFORE SAVING - NEEDS FIXING ASAP
  const saveIfRequired = () => {
    if (!selectedMessage) {
      console.error(`No message found for group: ${selectedMessage}`);
      return;
    }

    if (saveTemplate) {
      const updatedMessage = { ...selectedMessage };
  
      if (saveAsNewTemplate) {
        updatedMessage.newTemplateName = newTemplateName; // Add the new template name if saving as a new template
      }  
  
      updatedMessage.bcc = bccFlag && bccEmail ? bccEmail : null; // Update the BCC email if flag is set
  
      // Call the onMessageUpdate function with the updated message
      if (onMessageUpdate && typeof onMessageUpdate === "function") {
        console.log("Trying to call the update function");
        onMessageUpdate(updatedMessage);
      }
    }

  }

  const toggleRecipients = () => {
    saveIfRequired();

     // Only compile recipients if opening the area and the data doesn't exist yet
     if (!showRecipients) {
      if(!dataCompiled)
        findRecipients(selectedMessage);
    } else {
      setActions({
        ...actions,
        checkRecipients: true,
      });
    }
    
    setShowConfigure(false);
    setShowRecipients((prev) => !prev);
    setDataCompiled(true); 
  };

  const handleTemplateChange = (e) => {
    const { value } = e.target;
    console.log("Template changed");
  
    setSelectedMessage({
      ...selectedMessage,
      template: value,
    });
  
    setActions((prev) => ({
      ...prev,
      editTemplate: true,
    }));

    setDataCompiled(false);
  };

  const handleSubjectChange = (e) => {
    const { value } = e.target;
    console.log("Subject changed");

    setSelectedMessage({
      ...selectedMessage,
      subject: value,
    });
  
    setActions((prev) => ({
      ...prev,
      editTemplate: true,
    }));
    
    setDataCompiled(false);
  };

  const handleSendTest = async () => {
    const email = testEmail;

    // Regex for validating email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
        alert("Invalid email address. Please enter a valid email.");
        return;
    }

    if(bccFlag) {
      if (!emailRegex.test(bccEmail)) {
        alert("Invalid bcc email address. Please enter a valid email.");
        return;
      }
    }

    const message =selectedMessage; // Get the entire message object
    if (!message) {
      console.error(`No message found for group: ${selectedMessage}`);
      return;
    }

    const emailMessage = compiledEmailObjects.find(messageObject => messageObject.label = message.label);

    // Log the values for now (can replace with actual API call)
    console.log("Sending test email to:", email);
    console.log("BCC:", bccFlag);
    console.log("emailMessage:", emailMessage);
    console.log("bccEmail:", bccEmail);

    /*
        // Calculate the expireAt time (90 days from now) in epoch second format
        const expire_at = Math.floor((Date.now() + 90 * 24 * 60 * 60 * 1000) / 1000);

        // DataStore will take care of the new event's ID
        const newEventItem = new Events({
            event: "submissionComplete",
            userId: currentUser?.id,
            category: "REQUEST",
            projectToken: currentForm?.projectToken,
            payload: {submissionId: currentSubmission.id, formToken:currentSubmission.formToken},
            ttl: expire_at
        });

        console.log(newEventItem);

        try {
            await DataStore.save(newEventItem);
        } catch (e) {
            console.error("Error saving event:", e);
        }
*/
    try {
      const response = await fetch(LambdaURLs.HANDLE_ERROR, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          message: emailMessage.body,  // Aligns with the `message` field expected by the Lambda
          recipient: email,  // You need to specify a valid recipient
          subject: emailMessage.subject,
          bcc: bccFlag ? bccEmail : null,
        }),
      });

      if (!response.ok) {
        console.error("Error notifying Lambda:", response.statusText);
      } else {
        const responseData = await response.json();
        console.log("Error notification sent to Lambda:", responseData);
      }
    } catch (err) {
      console.error("Error making request to Lambda:", err);
    }




      alert("Test email sent successfully!");
  };

const sendEmails = async () => {
  //return;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Validate BCC email if flag is set
  if (bccFlag && !emailRegex.test(bccEmail)) {
    alert("Invalid BCC email address. Please enter a valid email.");
    return;
  }

  const message = selectedMessage; // Get the entire message object
  if (!message) {
    console.error(`No message found for group: ${selectedMessage}`);
    return;
  }

  // Loop through the compiled email objects and send each email
  for (const emailObject of compiledEmailObjects) {
    const { recipient, body, subject } = emailObject;
    const recipientEmail = recipient.email;

    // Prepare the email body for sending
    const emailMessage = {
      message: body,
      recipient: recipientEmail,
      subject: subject || message.subject, // Use the message's subject if not provided
      bcc: bccFlag ? bccEmail : null, // Include BCC if flag is set
      replyTo: message.replyTo || null, // Include replyTo if provided
    };

    try {
      const response = await fetch(LambdaURLs.HANDLE_ERROR, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(emailMessage),
      });

      if (!response.ok) {
        console.error("Error notifying Lambda:", response.statusText);
      } else {
        const responseData = await response.json();
        console.log("Email notification sent to Lambda:", responseData);
      }
    } catch (err) {
      console.error("Error making request to Lambda:", err);
    }
  }

  alert("Emails sent successfully!");
};

  const getEmailContent = (email) => {  
    // If compiledEmailObjects is not set, return a placeholder
    if (!compiledEmailObjects || compiledEmailObjects.length === 0) {
      return "No email content available.";
    }
  
    // Find the message object with the matching recipient email
    const message = compiledEmailObjects.find(
      (item) => item.recipient?.email === email
    );
  
    // Return the body of the message or a fallback if not found
    return message?.body || "No email content available.";
  };

  const processMessageTemplateForDisplay = (inputText = null) => {
    // Determine the text to process
    const textToProcess = inputText || selectedMessage?.template || "";
  
    // Process the text by adding line breaks between paragraph tags
    return textToProcess.replaceAll("</p><p>", "</p>\n<p>");
  };

  const processEmailBodyForHTML = (inputText = null) => {
    // Determine the text to process
    const textToProcess = inputText || selectedMessage?.message || "";
  
    // Process the text by adding line breaks between paragraph tags
    return textToProcess.replaceAll("</p>\n<p>", "</p><p>");
  };

  const buildTree = () => {
    return recipientList.map((recipient) => {
      const isExpandedRecipient = recipient.email === expandedRecipient;
  
      return (
        <TreeItem
          key={recipient.email}
          itemId={recipient.email}
          label={
            <span className={`MuiTreeItem-label ${isExpandedRecipient ? "expanded" : ""}`}>
              <FaceIcon className="label-icon-white" />
              {recipient.givenName} {recipient.familyName} - {recipient.email} ({recipient.count})
            </span>
          }
          onClick={() =>
            setExpandedRecipient(isExpandedRecipient ? null : recipient.email)
          }
          className="recipient-tree-item"
          expandicon={<ChevronRightIcon />}
          collapseicon={<ExpandMoreIcon />}
        >
          {/* Render actual content when expanded, placeholder otherwise */}
          {isExpandedRecipient ? (
            <TreeItem
              key={`${recipient.email}-content`}
              itemId={`${recipient.email}-content`}
              label={
                <div className="email-content">
                  {parse(getEmailContent(recipient.email))} {/* Safely render HTML */}
                </div>
              }
              className="email-content-item"
            />
          ) : (
            // Placeholder child ensures the chevron is always visible
            <TreeItem
              key={`${recipient.email}-placeholder`}
              itemId={`${recipient.email}-placeholder`}
              label={null} // Invisible placeholder child
              className="placeholder-item"
            />
          )}
        </TreeItem>
      );
    });
  };  

  return (
    <div className={`email-container ${expanded ? 'email-expanded' : ''}`}>
      <div className={`main-container`}>
        <div className="header-container">
          <h3>Distribution Groups</h3>

          {/* Configure Button */}
          <div className="configure-options-btn-item">
            <button
              disabled={!(actions.chooseGroup && actions.editTemplate)}
              className="configure-options-btn"
              onClick={toggleConfigure}
            >
              <MiscellaneousServicesIcon className="button-icon"/>
              Configure
            </button>
          </div> 

          {/* View Recipients Button */}
          <div className="view-recipients-btn-item">
            <button
              disabled={!(actions.chooseGroup && actions.editTemplate)}
              className="view-recipients-btn"
              onClick={toggleRecipients}
            >
              <GradingIcon/>
              Recipients
            </button>
          </div> 
          
          {/* Send Emails Button */}
          <div className="send-email-btn-item">
            <button
              disabled={!(actions.chooseGroup && actions.editTemplate && actions.checkRecipients)}
              className="send-email-btn"
              onClick={sendEmails}
            >
              <MailIcon/>
              Send
            </button>
          </div> 

          {/* Recipients Area */}
          <div className={`recipients-area ${showRecipients ? "open" : ""}`}>
            <h3>Recipient List <em>({compiledEmailObjects.length} emails to {recipientList.length} recipients)</em></h3>
            <SimpleTreeView >
              {buildTree()}
            </SimpleTreeView>
          </div>

          {/* Configure Area */}
          <div className={`configure-area ${showConfigure ? "open" : ""}`}>
              <div className="configure-header">Configure Options</div>
              
              {/* Recipient Information */}
              <div className="recipient-summary">
                  <p>
                      {recipientList.length > 0
                          ? `There are currently ${recipientList.reduce((total, recipient) => total + recipient.count, 0)} recipients for this email.`
                          : "No recipients available."
                      }
                  </p>
              </div>

              <hr className="configure-horizontal-rule" />

              {/* BCC Checkbox */}
              <div className="configure-header">BCC</div>
              <div className="bcc-option">
                <div className="mySwitch">
                  <MaterialUISwitch
                    checked={bccFlag}
                    onChange={(e) => setBccFlag(e.target.checked)}
                  />
                  Send a copy{bccFlag ? ' to' : '.'}
                </div>

                {/* Show "BCC email address" only if "Send a copy" is checked */}
                {bccFlag && (
                  <input
                    className="input-box"
                    type="text"
                    id="bcc-email"
                    placeholder="Enter email address"
                    onChange={(e) => setBccEmail(e.target.value)}
                    value={bccEmail}
                  />
                )}                
              </div>

              <hr className="configure-horizontal-rule" />

              {/* Send Test Message Section */}
              <div className="configure-header">Send a Test Message</div>               
              <div className="test-email-option">
                <div className="mySwitch">
                  <MaterialUISwitch
                    
                    checked={testEmailFlag}
                    onChange={(e) => setTestEmailFlag(e.target.checked)}
                  />
                  Send test email{testEmailFlag ? ' to' : '.'}
                </div>

                {/* Show "Test email address" only if "Send test email" is checked */}
                {testEmailFlag && (
                  <input
                    className="input-box"
                    type="text"
                    id="test-email"
                    placeholder="Enter email address"
                    onChange={(e) => setTestEmail(e.target.value)}
                    value={testEmail}
                  />
                )}                
              </div>
              {/* Send Test Button */}
              {testEmailFlag && (
                <div className="send-test-button">
                    <button className="configure-options-btn" onClick={handleSendTest}>Send Test Email</button>
                </div>
              )}
          </div>

        </div>
        
        <div className="distribution-group-list">
          {messages &&
            Object.keys(messages).map((key) => {
              const group = messages[key];
              return (
                <Button
                  key={key}
                  variant="contained"
                  className={`distribution-group-item ${selectedMessage === key ? 'selected' : ''}`}
                  onClick={() => handleGroupSelect(key)}
                >
                  <GroupIcon fontSize="large" />
                  <div className="distribution-group-item-label">{group.label}</div>
                </Button>
              );
            })}
        </div>

        <hr className="horizontal-rule" />

        {/* Middle Section: Checklist */}
        <div className="checklist">
          <div className="checklist-item">
            <span className='text'><u>CHECKLIST ITEMS</u></span>
            <span className='instruction'>                
                <>
                  <u><span className="tick-sm">✔</span><span className='split'>/</span><span className="cross-sm">❌</span></u>
                </>                
                <>                    
                  <span className="header-text"><u>ADVICE</u></span>
                </>                
            </span>
          </div>
          
          <div className="checklist-item">
            <span className='text'>1) Choose a distribution group</span>
            <span className='instruction'>
                {actions.chooseGroup ? (
                <>
                  <span className="tick">✔</span>
                  <span className="tick-item-text"> Done!</span>
                </>
                ) : (
                <>
                  <span className="cross">❌</span>
                  <span className="cross-item-text">*Choose a group*</span>
                </>
                )}
            </span>
          </div>

          <div className="checklist-item">
            <span className='text'>2) Edit the template</span>
            <span className='instruction'>
              <button
                disabled={actions.editTemplate}
                onClick={() => handleActionChange('editTemplate')}
              >
                {actions.editTemplate ? (
                  <>
                    <span className="tick">✔</span>
                    <span className="tick-item-text"> Done!</span>
                  </>
                ) : (
                  <>
                    <span className="cross">❌</span>
                    <span className="cross-item-text">*Click when finished*</span>
                  </>
                )}
              </button>
            </span>
          </div>

          <div className="checklist-item">
            <span className='text'>3) Configure options</span>
            <span className='instruction'>
              <button
                disabled={actions.configureOptions}
                onClick={() => handleActionChange('configureOptions')}
              >
                {actions.configureOptions ? (
                  <>
                    <span className="tick">✔</span>
                    <span className="tick-item-text"> Done!</span>
                  </>
                ) : (
                  <>
                    <span className="cross">❌</span>
                    <span className="cross-item-text"> Optional - click to confirm</span>
                  </>
                )}
              </button>
            </span>
          </div>

          <div className="checklist-item">
            <span className='text'>4) Send a test message</span>
            <span className='instruction'>
              <button
                disabled={actions.sendTestMessage}
                onClick={() => handleActionChange('sendTestMessage')}
              >
                {actions.sendTestMessage ? (
                  <>
                    <span className="tick">✔</span>
                    <span className="tick-item-text"> Done!</span>
                  </>
                ) : (
                  <>
                    <span className="cross">❌</span>
                    <span className="cross-item-text"> Optional - click to confirm</span>
                  </>
                )}
              </button>
            </span>
          </div>

          <div className="checklist-item">
            <span className='text'>5) Check the recipients</span>
              <span className='instruction'>
                <button
                disabled={actions.checkRecipients}
                onClick={() => handleActionChange('checkRecipients')}
                >
                {actions.checkRecipients ? (
                  <>
                    <span className="tick">✔</span>
                    <span className="tick-item-text"> Done!</span>
                  </>
                ) : (
                  <>
                    <span className="cross">❌</span>
                    <span className="cross-item-text"> Click when finished</span>
                  </>
                )}
                </button>
            </span>
          </div>
        </div> 

        <hr className="horizontal-rule" />     

        {/* Email template section */}
        <div className="email-template-section">
          <div className="content-label">Edit Email Template</div>          
          
          <div className="email-input">
            <label>{newTemplateName}</label>
            <label>Subject: </label>
            <input
              className='email-input-control'
              type="text"
              defaultValue={selectedMessage?.subject || ""}
              onChange={handleSubjectChange}
              onBlur={handleSubjectChange}
            />
          </div>

          <div>
           {/* <div className="email-template-input" >Edit Template:</div> */}
            <textarea
              id="email-template"
              className="plain-text-editor"
              defaultValue={processMessageTemplateForDisplay()}
              placeholder="Enter email template here..."
              onChange={handleTemplateChange}
              onBlur={handleTemplateChange}
            />
          </div>

          <div className="save-template">
            {/* Checkbox for saving the template */}
            <div className="mySwitch">
              <MaterialUISwitch
                checked={saveTemplate}
                onChange={(e) => setSaveTemplate(e.target.checked)}
              />
              Save Template
            </div>

            {/* Show "Save as New Template" checkbox only if "Save Template" is checked */}
            {saveTemplate && (
            <div className="mySwitch">
              <MaterialUISwitch
                checked={saveAsNewTemplate}
                onChange={(e) => setSaveAsNewTemplate(e.target.checked)}
              />
              Save as New Template
            </div>
            )}

            {/* Show input field for new template name only if "Save as New Template" is checked */}
            {saveTemplate && saveAsNewTemplate && (
              <input
                type="text"
                value={newTemplateName}
                onChange={(e) => setNewTemplateName(e.target.value)}
                placeholder="New template name"
              />
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default Email;
